import React from 'react';
import PropTypes from 'prop-types';

import useBranch from 'client/hooks/useBranch';
import useDispatch from 'client/hooks/useDispatch';
import AnnouncementsActions from 'client/actions/Announcements';
import { UTILITY_ANNOUNCEMENT_TYPE_RENTERS_INSURANCE } from 'common/utility/constants';

import SrButton, {
  SR_BUTTON_HEIGHT_SHORT,
  SR_BUTTON_THEME_ADOBE_BLUE,
} from 'client/components/SrButton/SrButton';

import './RenterInsuranceWaitlistPrompt.less';

const RenterInsuranceWaitlistPrompt = ({ utilityPartner, utilityUser, onClose }) => {
  const dispatch = useDispatch();
  const { rentersInsuranceWaitlistTypeformId } = useBranch({
    rentersInsuranceWaitlistTypeformId: ['env', 'TYPEFORM_FORM_ID_RENTERS_INSURANCE_WAITLIST'],
  });

  const onShowRentersInsuranceWaitlist = () => {
    if (!rentersInsuranceWaitlistTypeformId) {
      onClose();
      return;
    }

    const baseUrl = `https://sunroom.typeform.com/to/${rentersInsuranceWaitlistTypeformId}`;
    const params = new URLSearchParams({
      first_name: utilityUser.firstName,
      last_name: utilityUser.lastName,
      email: utilityUser.email,
      partner: utilityPartner.name,
      partnerslug: utilityPartner.slug,
      partnerdoorcount: String(utilityPartner.doorsUnderManagement || 0),
      partnerpms: utilityPartner.propertyManagementSoftware?.name ?? 'None',
    });

    const formUrl = `${baseUrl}#${params.toString()}`;

    // Open the form in a new tab
    global.open(formUrl, '_blank');
  };

  const onDismiss = () => {
    dispatch(AnnouncementsActions.trackDismiss, {
      utilityPartnerId: utilityPartner.id,
      utilityUserId: utilityUser.id,
      type: UTILITY_ANNOUNCEMENT_TYPE_RENTERS_INSURANCE,
    });

    onClose();
  };

  return (
    <div styleName="page">
      <div styleName="skip">
        <span onClick={onDismiss}>Skip for now</span>
        <div styleName="x" onClick={onDismiss} />
      </div>
      <div styleName="content">
        <img styleName="icon" src="/images/insurance-logo.svg" alt="Insurance Logo" />
        <span styleName="title">
          ✨ Get early access to Utility Profit's{' '}
          <span styleName="coloredText">new liability insurance </span> add-on
        </span>
        <SrButton
          width="200px"
          theme={SR_BUTTON_THEME_ADOBE_BLUE}
          heightType={SR_BUTTON_HEIGHT_SHORT}
          hasBoxShadow
          onClick={onShowRentersInsuranceWaitlist}
          themeOverrides={{
            fontSize: '16px',
            padding: '0px 15px 2px',
          }}
        >
          Join the waitlist
        </SrButton>
      </div>
    </div>
  );
};

RenterInsuranceWaitlistPrompt.propTypes = {
  utilityPartner: PropTypes.object.isRequired,
  utilityUser: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

RenterInsuranceWaitlistPrompt.displayName = 'RenterInsuranceWaitlistPrompt';

export default RenterInsuranceWaitlistPrompt;
